import { addHours, format } from "date-fns"
import React from "react"
import { useTranslation } from "react-i18next"

import type { PaymentMethodNameEnum } from "@/enums"
import { CycleStatusEnum } from "@/enums/subscriptions"
import {
  useSubscriptionById,
  useSubscriptionCycles,
} from "@/hooks"

import {
  TimelineContainer,
  TimelineItem,
} from "../commons/app-timeline"
import {
  getCycleStatusInfo,
  isCancelPaymentMethodByType,
} from "./SubscriptionsHelper"
type SubscriptionsTimelineProps = {
  subscription: SubscriptionType
}
export const SubscriptionsTimeline: React.FC<
  SubscriptionsTimelineProps
> = ({ subscription }) => {
  const { t } = useTranslation()
  const { data, isFetching } = useSubscriptionCycles(
    subscription?.id
  )
  const {
    data: subscriptionDetails,
    isFetching: isFetchingDetails,
  } = useSubscriptionById(subscription?.id)

  const paymentMethod = subscriptionDetails
    ?.paymentMethods?.[0]?.type as
    PaymentMethodNameEnum | undefined
  const isCancelPaymentMethod =
    isCancelPaymentMethodByType(paymentMethod)

  if (isFetching || isFetchingDetails) {
    return <div>Carregando...</div>
  }
  return (
    <TimelineContainer data={data} itemSpacing={80}>
      <div>
        {data?.map((item, index: number) => {
          const spaceBetween = (index + 1) * 80
          const statusInfo = getCycleStatusInfo(
            item.status,
            t,
            paymentMethod
          )

          let tooltipMessage = `Parcela ${item.billingCycle} - ${item.statusDetail?.description}`
          if (
            isCancelPaymentMethod &&
            [
              CycleStatusEnum.REVERSED,
              CycleStatusEnum.PROCESSING_REVERSING,
            ].includes(item.status as CycleStatusEnum) &&
            tooltipMessage
          ) {
            tooltipMessage = tooltipMessage.replaceAll(
              /estornado/gi,
              "cancelado"
            )
          }
          return (
            <TimelineItem
              key={index}
              colors={{ bg: statusInfo.bgColor }}
              spaceBetween={spaceBetween}
              tooltip={tooltipMessage}
            >
              <p>
                {item.billingCycle} - {statusInfo.label}
              </p>
              <p>
                {format(
                  addHours(item.dueDate, 3),
                  "dd/MM/yyyy"
                )}
              </p>
            </TimelineItem>
          )
        })}
      </div>
    </TimelineContainer>
  )
}
